import React, { Component } from 'react';

class AccountSelectItem extends Component {

    constructor() {
        super()
        this.onClick = this.onClick.bind(this)
    }

    render() {
        const itemTitle = this.props.name 
        if (this.props.selected) {
            return <button className="dropdown-item selected" onClick={this.onClick}>{itemTitle}</button>
        } else {
            return <button className="dropdown-item" onClick={this.onClick}>{itemTitle}</button>
        }
    }

    onClick(event) {
        this.props.onClick(this.props.id);
    }
}

export default AccountSelectItem